import "./style/globals.css";
import "./style/animations.css";

import Providers from "./store/Provider";
import { getQueryParamFromUrl } from "./helpers/url";
import { scrollToSection } from "./helpers/scroll";
import { useEffect } from "react";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";
import ModalLayout from "./Modals/ModalLayout/ModalLayout";
import PageLayout from "./pages/layout/PageLayout";

function App() {
  // id: "GTM-PN2Q4QJ"
  const gtmParams = { id: "" };
  return (
    <Providers>
      <GTMProvider state={gtmParams}>
        <PageLayout />
        <ModalLayout />
      </GTMProvider>
    </Providers>
  );
}
export default App;
